import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { getFLFRogoDevSubType } from "src/apis/FLF/rogoDevSubType.api";
import { getFLFRogoDevType } from "src/apis/FLF/rogoDevType.api";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { validationFLFHomeIndexInput } from "src/pages/FPTLife/utils/validateInput";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { isDisableSubmit } from "src/utils";
import { getFLFCategory } from "src/apis/FLF/category.api";
import { getFLFQueryType } from "src/apis/FLF/queryType.api";

const initialValue = {
  id: "",
  flfCategoryId: "",
  flfQueryTypeId: "",
  description: "",
  isContext: false,
  devTypeCodes: [],
  devSubTypeCodes: [],
};

const contextTypeOption = [
  {
    id: true,
    name: "True",
  },
  {
    id: false,
    name: "False",
  },
];

const FLFHomeIndexForm = (props) => {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [listRogoDevTypeCode, setListRogoDevTypeCode] = useState([]);
  const [listRogoDevSubTypeCode, setListRogoDevSubTypeCode] = useState([]);
  const [categories, setCategories] = useState([]);
  const [queryTypes, setQueryTypes] = useState([]);
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  const validateFLFHomeIndexForm = (fieldValues = values) => {
    let temp = validationFLFHomeIndexInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFHomeIndexForm);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateFLFHomeIndexForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    getFLFRogoDevType({}, (result) => {
      setListRogoDevTypeCode([...result.list]);
    });

    getFLFRogoDevSubType({}, (result) => {
      setListRogoDevSubTypeCode([...result.list]);
    });

    getFLFCategory({}, (result) => {
      setCategories([...result.list]);
    });

    getFLFQueryType({}, (result) => {
      setQueryTypes([...result.list]);
    });
  }, []);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;

      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Select
        name="flfCategoryId"
        label="Category"
        value={values.flfCategoryId}
        onChange={handleOnChange}
        options={categories}
        searchable={true}
        error={Boolean(errors.flfCategoryId)}
      />

      <Controls.Select
        name="flfQueryTypeId"
        label="Query Type"
        value={values.flfQueryTypeId}
        onChange={handleOnChange}
        options={queryTypes}
        searchable={true}
        error={Boolean(errors.flfQueryTypeId)}
      />

      <Accordion
        sx={{
          borderRadius: "4px",
          margin: "10px 0",
          padding: "3px 0px",
          background: "unset",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>RogoDevTypeCode</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "200px",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="devTypeCodes"
            label="RogoDevTypeCode"
            value={values.devTypeCodes}
            onChange={handleOnChange}
            options={listRogoDevTypeCode.map((code) => ({
              ...code,
              id: +code.devTypeCode,
              name: `${code.name} -  ${code.devTypeCode}`,
            }))}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        sx={{
          borderRadius: "4px",
          margin: "20px 0 10px 0",
          padding: "3px 0px",
          background: "unset",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>RogoDevSubTypeCode</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "200px",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="devSubTypeCodes"
            label="RogoDevSubTypeCode"
            value={values.devSubTypeCodes}
            onChange={handleOnChange}
            options={listRogoDevSubTypeCode.map((code) => ({
              ...code,
              id: +code.devSubTypeCode,
              name: `${code.name} -  ${code.devSubTypeCode}`,
            }))}
          />
        </AccordionDetails>
      </Accordion>

      <Controls.Select
        name="isContext"
        label="Use in context"
        value={values.isContext}
        onChange={handleOnChange}
        options={contextTypeOption}
        error={errors.type}
      />

      <Controls.Input
        name="description"
        value={values.description}
        label="Description"
        type="text"
        minRows={3}
        multiline
        onChange={handleOnChange}
        error={errors.description}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
};

export default FLFHomeIndexForm;
